import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_IHPERSONA = `${API_URL}/datospersona/`;

export async function getDatosIhPersona() {
  return await axios({
    method: "GET",
    url: GET_IHPERSONA,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los datos de IHPERSONA")
    );
}
